import { motion } from "framer-motion";

const NOTES = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
const OCTAVE_LABELS = {
  "4": { name: "Emotional", tone: "Octave 4" },
  "5": { name: "Physical", tone: "Octave 5" },
  "6": { name: "Blood Biomarkers", tone: "Octave 6" },
};

const STATUS = {
  strong: { cls: "bg-primary text-primary-foreground border-primary", label: "Strong" },
  normal: { cls: "bg-accent/70 text-foreground border-accent", label: "Balanced" },
  weak: { cls: "bg-secondary text-muted-foreground border-border", label: "Weak" },
  missing: { cls: "bg-transparent text-muted-foreground/50 border-dashed border-border", label: "Missing" },
};

export default function OctaveGrid({ grid }) {
  if (!grid) return null;
  return (
    <div className="space-y-6" data-testid="octave-grid">
      <div className="flex flex-wrap gap-4">
        {Object.entries(STATUS).map(([k, v]) => (
          <div key={k} className="flex items-center gap-2 text-xs text-muted-foreground">
            <span className={`h-3.5 w-3.5 rounded border ${v.cls}`} />
            {v.label}
          </div>
        ))}
      </div>
      {["4", "5", "6"].map((oct) => (
        <div key={oct}>
          <div className="flex items-baseline justify-between mb-2">
            <span className="font-serif text-lg">{OCTAVE_LABELS[oct].name}</span>
            <span className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{OCTAVE_LABELS[oct].tone}</span>
          </div>
          <div className="grid grid-cols-6 sm:grid-cols-12 gap-1.5">
            {(grid[oct] || []).map((cell, i) => {
              const s = STATUS[cell.status] || STATUS.missing;
              return (
                <motion.div
                  key={cell.note}
                  initial={{ opacity: 0, y: 8 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.02 }}
                  className={`aspect-square rounded-md border flex flex-col items-center justify-center ${s.cls}`}
                  data-testid={`octave-${oct}-note-${cell.note}`}
                  title={`${cell.note}${oct} · ${s.label} · ${cell.hits} hits`}
                >
                  <span className="text-xs font-semibold">{cell.note}</span>
                  <span className="text-[9px] opacity-70">{cell.hits}</span>
                </motion.div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
